(function () {
  var SEARCH_PAGE = '/pages/search-results-page';
  var INIT_URL = 'https://searchanise-ef84.kxcdn.com/widgets/shopify/init.js?a=7i6v2Z3S9H';
  var isSearchPage =
    window.location.pathname.indexOf(SEARCH_PAGE) !== -1 ||
    window.location.pathname === '/search';

  if (!isSearchPage) return;

  function hasProducts() {
    return document.querySelectorAll('.snize-product').length > 0;
  }

  function removeSkeleton() {
    var skeleton = document.getElementById('snize_skeleton_results');
    if (!skeleton) return true;

    if (hasProducts() || document.querySelector('.snize-search-results-content')) {
      skeleton.remove();
      return true;
    }

    return false;
  }

  function reloadSearchanise() {
    if (hasProducts()) return;

    window.SearchaniseIncluded = false;
    var existing = document.querySelector('script[src*="widgets/shopify/init.js"]');
    if (existing) existing.remove();

    var script = document.createElement('script');
    script.src = INIT_URL;
    script.async = false;
    document.body.appendChild(script);
  }

  var started = Date.now();
  var poll = setInterval(function () {
    if (removeSkeleton()) clearInterval(poll);
  }, 100);

  setTimeout(function () {
    clearInterval(poll);
    if (removeSkeleton()) return;

    if (Date.now() - started >= 8000 && !hasProducts()) {
      reloadSearchanise();
    }
  }, 8000);

  setTimeout(function () {
    if (!removeSkeleton() && !hasProducts()) {
      var skeleton = document.getElementById('snize_skeleton_results');
      if (!skeleton) return;

      var message = document.createElement('p');
      message.className = 'snize-search-error-message';
      message.style.cssText = 'padding:24px;text-align:center;color:#333;';
      message.textContent =
        'Search is taking longer than expected. Please refresh the page or try again.';
      skeleton.parentNode.insertBefore(message, skeleton.nextSibling);
    }
  }, 20000);

  /* -----------------------------------------------------------------------
   * Enhance Searchanise (snize) product cards with the theme's real stock
   * status (In Stock / Pre-Order / Back Order / Sold Out) and colour swatches.
   * Searchanise renders its own cards and has none of the theme's status/colour
   * logic, so for each card we fetch a tiny theme-rendered meta block
   * (/products/{handle}?view=ajax_search_meta) and inject it. Results are cached
   * per handle; a MutationObserver re-runs it for cards added by filter/paging.
   * --------------------------------------------------------------------- */
  (function () {
    var metaCache = {};
    // Status class -> { badge background, add-to-cart label }. Colours match
    // Searchanise's own badge palette so corrected badges look native.
    var STATUS = {
      'In-Stock':  { bg: '',        label: 'Add to cart' },
      'Pre-Order': { bg: '#1f35ff', label: 'Pre-Order' },
      'Back-Order':{ bg: '#333333', label: 'Back-Order' },
      'Sold-Out':  { bg: '#777777', label: 'Sold Out' }
    };
    var STATUS_RE = /(back[\s-]?order|pre[\s-]?order|sold[\s-]?out|out of stock)/i;

    function injectStyleOnce() {
      if (document.getElementById('hdx-search-meta-style')) return;
      var css =
        /* Hide Searchanise's (often stale) pre/back-order badge on items the
           theme reports as in stock. CSS persists even if Searchanise re-renders
           the badge inside the same card. */
        '.snize-product[data-hdx-status="In-Stock"] .snize-pre-order{display:none!important}' +
        '.hdx-search-swatch{margin:6px 0;width:100%}' +
        '.hdx-search-swatch .card-swatch{margin:0}' +
        '.hdx-search-swatch .card-swatch .swatch{display:flex;flex-wrap:wrap;gap:6px;margin:0;padding:0;list-style:none}' +
        '.hdx-search-swatch .card-swatch .swatch .pattern{display:inline-block;width:18px;height:18px;border-radius:50%;border:1px solid #ccc;font-size:0}';
      var style = document.createElement('style');
      style.id = 'hdx-search-meta-style';
      style.textContent = css;
      document.head.appendChild(style);
    }

    function getHandle(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return null;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
      return m ? m[1] : null;
    }

    function fetchMeta(handle) {
      if (metaCache[handle]) return metaCache[handle];
      metaCache[handle] = fetch('/products/' + handle + '?view=ajax_search_meta', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
      return metaCache[handle];
    }

    // Correct Searchanise's status badge to the theme's real status.
    function applyStatusBadge(card, status, statusText) {
      var conf = STATUS[status];
      if (!conf) return;
      var badge = card.querySelector('.snize-pre-order');
      if (status === 'In-Stock') {
        if (badge) badge.style.display = 'none'; // wrong pre/back-order label on an in-stock item
      } else if (badge) {
        badge.textContent = statusText;
        if (conf.bg) { badge.style.background = conf.bg; badge.style.backgroundColor = conf.bg; }
        badge.style.color = '#FFFFFF';
        badge.style.display = '';
      }
    }

    // Fix the add-to-cart button label when Searchanise mislabels it (e.g. an
    // in-stock product showing "BACK-ORDER"). Only rewrites status words; keeps icons.
    function correctButtonLabel(card, status, statusText) {
      var conf = STATUS[status];
      if (!conf) return;
      var desired = status === 'In-Stock' ? conf.label : statusText;
      var buttons = card.querySelectorAll(
        '.snize-add-to-cart, .snize-add-to-cart-button, [class*="snize"][class*="add-to-cart"], .snize-button'
      );
      buttons.forEach(function (btn) {
        var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
          var raw = node.nodeValue;
          if (raw && STATUS_RE.test(raw.trim())) {
            node.nodeValue = raw.replace(STATUS_RE, desired);
          }
        }
      });
    }

    function insertSwatch(card, meta) {
      var swatch = meta.querySelector('.card-swatch');
      if (!swatch || card.querySelector('.hdx-search-swatch')) return;
      var holder = document.createElement('div');
      holder.className = 'hdx-search-swatch';
      holder.appendChild(swatch);
      var anchor =
        card.querySelector('.snize-price-list') ||
        card.querySelector('.snize-price') ||
        card.querySelector('.snize-title');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(holder, anchor.nextSibling);
      } else {
        card.appendChild(holder);
      }
    }

    function enhanceCard(card) {
      if (card.getAttribute('data-hdx-enhanced')) return;
      card.setAttribute('data-hdx-enhanced', '1');
      var handle = getHandle(card);
      if (!handle) return;
      fetchMeta(handle).then(function (html) {
        if (!html || !html.trim()) return;
        var wrap = document.createElement('div');
        wrap.innerHTML = html.trim();
        var meta = wrap.firstElementChild;
        if (!meta) return;
        var status = meta.getAttribute('data-status') || '';
        // Fall back to the label for status when data-status-text is absent
        // (e.g. an older cached meta snippet), so the enhancer stays robust.
        var statusText = meta.getAttribute('data-status-text') ||
          (STATUS[status] && status !== 'In-Stock' ? STATUS[status].label : '');
        // Tag the card so the CSS rule can hide a re-rendered stale badge.
        if (status) card.setAttribute('data-hdx-status', status);
        applyStatusBadge(card, status, statusText);
        correctButtonLabel(card, status, statusText);
        insertSwatch(card, meta);
      });
    }

    function processAll() {
      var cards = document.querySelectorAll('.snize-product');
      if (!cards.length) return;
      injectStyleOnce();
      cards.forEach(enhanceCard);
    }

    var debounce;
    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(processAll, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Initial passes (Searchanise may render before or after this runs).
    processAll();
    setTimeout(processAll, 1000);
    setTimeout(processAll, 3000);
  })();
})();
